import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function getSelectedCalendars(): string[] {
    const selectedCalendars = getUserConfiguration().ViewStateConfiguration
        .SelectedCalendarsDesktop;
    return selectedCalendars ? selectedCalendars : [];
}
